import { Helmet } from 'react-helmet-async';
// import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useState } from "react";
import {
  Button,
  Stack,
  Typography,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  Container
} from '@mui/material';


import { styled } from '@mui/material/styles';
// import { Button, Typography, Container, Box, Stack } from '@mui/material';
import {  toast } from 'react-toastify';
// import logo from '/build/assets/logoBlue.png';
import { useSearchParams } from "react-router-dom";
import { Api } from '../webservices';




// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));



// ----------------------------------------------------------------------

export default function AiInterview() {
    const [searchParams] = useSearchParams();

const jobTitle = searchParams.get("jobTitle");
const clientName = searchParams.get("clientName");
const fullName = searchParams.get("fullName");
const date = searchParams.get("date");
const time = searchParams.get("time");
const timezone = searchParams.get("timezone");
const interviewToken = searchParams.get("interviewToken");
const token = searchParams.get("token");
const interviewId = searchParams.get("interviewId");
const adminName = searchParams.get("adminName");
const requestSchedule = searchParams.get("requestSchedule");
const interviewMinScore = searchParams.get("interviewMinScore");
const jobId = searchParams.get("jobId");
const jobsId = searchParams.get("jobsId");
const iclientName = searchParams.get("iclientName");
const resumeId = searchParams.get("resumeId");



console.log("interviewId through Params",interviewId);

const [loading, setLoading] = useState(false);
const [selectedAction, setSelectedAction] = useState("");
const [openSchedule, setOpenSchedule] = useState(false);
 const [schedule, setSchedule] = useState({
                                            date: "",
                                            time: "",
                                          });

  const scheduleStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "450px" },
  bgcolor: "background.paper",
  border: "3px solid #3C6BA5",
  boxShadow: 24,
  borderRadius: 3,
  p: 3,
};

const [timez, setTimez] = useState({ short: "", full: "" });
     const timeZones = [
    { short: "EST", full: "America/New_York" },
    { short: "PST", full: "America/Los_Angeles" },
    { short: "MST", full: "America/Denver" },
    { short: "CST", full: "America/Chicago" },
    { short: "IST", full: "Asia/Kolkata" },
  ];

  const handleChangeTimeZ = (e) => {
    const selectedShort = e.target.value;
    const selectedZone = timeZones.find((tz) => tz.short === selectedShort);
    setTimez(selectedZone);
  };

const handleAccept = () => {
  updateInterviewStatus("accepted");
};

const handleReject = () => {
  updateInterviewStatus("rejected");
};

 const handleCloseSchedule = () => {
           setOpenSchedule(false);

             setSchedule({
                           date: "",
                           time: "",
                         });
                      setTimez   ({ short: "", full: "" })
                };

    const getInterviewDateTimeUTC = (date, time) => {
  if (!date || !time) return "";

  const localDate = new Date(`${date}T${time}:00`);

  return localDate.toISOString();
};             

const formatTimeToAMPM = (time) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");

  return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const updateInterviewStatus = async (action) => {
  try {
    setLoading(true);

   const link= `${window.location.origin}/interviewSession?jobTitle=${encodeURIComponent(
                      jobTitle
                      )}&clientName=${encodeURIComponent(
                      clientName
                      )}&fullName=${encodeURIComponent(
                       fullName 
                      )}&date=${encodeURIComponent(
                      requestSchedule === 'true' ? schedule.date : date
                      )}&time=${encodeURIComponent(
                      requestSchedule === 'true' ?  formatTimeToAMPM(schedule.time)  : time
                      )}&timezone=${encodeURIComponent(
                      requestSchedule === 'true' ? timez.short : timezone
                      )}&interviewId=${encodeURIComponent(
                        interviewId
                      )}&interviewToken=${encodeURIComponent(
                        interviewToken
                      )}&token=${encodeURIComponent(
                        token
                      )}&adminName=${encodeURIComponent(
                        adminName
                      )}&interviewMinScore=${encodeURIComponent(
                       interviewMinScore
                      )}&jobId=${encodeURIComponent(
                        jobId
                       )}&jobsId=${encodeURIComponent(
                        jobsId
                      )}&iclientName=${encodeURIComponent(
                      iclientName
                      )}&resumeId=${encodeURIComponent(
                        resumeId
                       )}`

    const payload = {
      interviewToken,
      action, // "accepted" | "rejected"
      ...(action === "accepted" && {
    interviewLink: link, // ya jis variable me link ho
    }),
     interviewDate: requestSchedule === 'true' ?  getInterviewDateTimeUTC(schedule.date,schedule.time ) : date,
    interviewTime: requestSchedule === 'true' ? formatTimeToAMPM(schedule.time) : time,
    timeZone: requestSchedule === 'true' ? timez.short : timezone,
    };

    const res = await Api(
      "bot/update_interview_status",
      "POST",
      payload,
      token
    );
  console.log("API RESPONSE =>", res);
    if (res?.data?.success) {
       console.log("API Response:", res);
  console.log("Interview Status:", res?.data?.interviewStatus);
      toast.success(
        // action === "accepted"
        //   ? "Interview accepted successfully."
        //   : "Interview rejected successfully."
        res.data.message
      );
      
     setSelectedAction(res.data.data.interviewStatus);
      console.log(res);
    } else {
      toast.error(res?.message || "Something went wrong");
    }
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      {/* <Helmet>
        <title> 404 Page Not Found </title>
      </Helmet> */}
  {/* <Box display="flex" justifyContent="center" alignItems="center"  mt={20} mb={2}>
  <img
    src="/assets/logoBlue.png"
    alt="Foxearch"
    style={{ width: 180, height: 'auto' }}
  />
</Box>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h6" paragraph>
            Your interview has been scheduled for the [Job Title] position at [Company Name] for [Day, DD Month YYYY] at [HH AM/PM]. 
          </Typography>

          <Typography variant="h6" sx={{ color: 'text.secondary' }}>
            We kindly request that you confirm your availability by accepting or rejecting this invitation using the options below.
          </Typography>

          {/* <Box
            component="img"
            src="/assets/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button to="/" size="large" variant="contained" component={RouterLink}>
            Go to Home
          </Button> */}
        {/* </StyledContent>
      </Container>  */}
     <Box
  sx={{
    height: "100vh",
    // p: 2,
       pt: 5,   // Top se niche
    pb: 2,
    px: 2,
    boxSizing: "border-box",
  }}
>
     <Container
    maxWidth="md"
    sx={{
      height: "90%",
      border: (theme) => `2px solid ${theme.palette.text.secondary}`,
      borderRadius: 2,
      px: 4,
      py: 4,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
  <StyledContent
    sx={{
      textAlign: "center",
    //   alignItems: "center",
      maxWidth: "900px", // Text ki width badh gayi
      mx: "auto",
    }}
  >
    <Box display="flex" justifyContent="center" mb={2} mt={-25}>
      {/* Logo aur text ke beech gap kam */}
      <img
        src="/assets/logoBlue.png"
        alt="Foxearch"
        style={{ width: 220, height: "auto" }}
      />
    </Box>

    <Typography
      variant="h5"
      sx={{
        fontWeight: 600,
        lineHeight: 1.7,
      }}
    >
      Your interview has been scheduled for the{" "}
      <strong>{jobTitle}</strong> position
       {clientName && (
        <>
      {" "} at{" "} <strong>{clientName || "N/A"}</strong> 
       </>
       )}
      {requestSchedule !== 'true' && (
         <>
          {" "}for{" "}<strong>{date}</strong> at{" "}
          
      <strong>{time} {timezone}</strong>
       </>
          )}
      .
    </Typography>

    <Typography
      variant="h6"
      sx={{
        mt: 2,
        color: "text.secondary",
        maxWidth: "850px",
        lineHeight: 1.8,
        mx: "auto",
      }}
    >
      We kindly request that you confirm your availability by accepting or
      rejecting this invitation using the options below.
    </Typography>
 {!selectedAction ? (
  <>
  <Stack
    direction="row"
    spacing={2}
    justifyContent="center"
    sx={{ mt: 4 }}
  >
    <Button
      variant="contained"
      // onClick={requestSchedule === true ? openSchedule(true) : handleAccept}
        onClick={() => {
    if (requestSchedule === 'true') {
      setOpenSchedule(true);
    } else {
      handleAccept();
    }
  }}
      disabled={loading}
      sx={{
        minWidth: 140,
        bgcolor: "text.secondary",
        color: "#fff",
        "&:hover": {
          bgcolor: "text.secondary",
          opacity: 0.9,
        },
      }}
    >
      {loading ? "Please wait..." : "Accept"}
    </Button>

    <Button
      variant="contained"
      onClick={handleReject}
      disabled={loading}
      sx={{
        minWidth: 140,
        bgcolor: "text.secondary",
        color: "#fff",
        "&:hover": {
          bgcolor: "text.secondary",
          opacity: 0.9,
        },
      }}
    >
      {loading ? "Please wait..." : "Reject"}
    </Button>
  </Stack>
  <Modal open={openSchedule} onClose={handleCloseSchedule}>
      <Box sx={scheduleStyle}>
        <Typography
             variant="h5"
             color="#3C6BA5"
             textAlign="center"
             fontWeight={600}
           >
             Schedule Interview
         </Typography>

       <Divider sx={{ my: 2 }} />

          <Stack spacing={3}>
            {/* Date */}
           <TextField
              label="Date"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={schedule.date}
             onChange={(e) =>
                  setSchedule({ ...schedule, date: e.target.value })
                 }
              />

            {/* Time */}
          <TextField
             label="Time"
               type="time"
               fullWidth
               InputLabelProps={{ shrink: true }}
               inputProps={{
                    step: 300, // 5 minutes
                   }}
                 value={schedule.time}
               onChange={(e) =>
                    setSchedule({ ...schedule, time: e.target.value })
                }
           />

               <FormControl sx={{ width: '100%', mt: 1 }}>
                                 <InputLabel id="demo-simple-select-autowidth-label">Time zone</InputLabel>
                                 <Select
                                   labelId="demo-simple-select-autowidth-label"
                                   id="demo-simple-select-autowidth"
                                   label="Time Zone"
                                   InputLabelProps={{ shrink: true }}
                                   placeholder="Time zone"
                                   // value={timez}
                                   // onChange={(e) => setTimez(e.target.value)}
                                   value={timez?.short}
                                   onChange={handleChangeTimeZ}
                                 >
                                   {/* <MenuItem value={'est'}>EST</MenuItem>
                                 <MenuItem value={'pst'}>PST</MenuItem>
                                 <MenuItem value={'mst'}>MST</MenuItem>
                                 <MenuItem value={'cst'}>CST</MenuItem>
                                 <MenuItem value={'ist'}>IST</MenuItem> */}
                                   {timeZones.map((tz) => (
                                     <MenuItem key={tz.short} value={tz.short}>
                                       {tz.short}
                                     </MenuItem>
                                   ))}
                                 </Select>
                               </FormControl>

          {/* Submit Button */}
      

          <Stack direction="column" spacing={2} alignItems="center">
         <Button
             variant="contained"
             color="custom"
             onClick={() => updateInterviewStatus('accepted')}
          >
            Schedule
         </Button>

         {/* <Typography
            variant="body2"
            sx={{
               color: "text.secondary",
               fontWeight: 600,
               whiteSpace: "nowrap",
             }}
           >
          -------------- OR --------------
        </Typography>

        <Button
            variant="contained"
            color="custom"
            onClick={() => handleSubmitInterview(true)}
         >
         Request to Schedule
        </Button> */}
       </Stack>
      </Stack>
    </Box>
  </Modal>
  </>
) : (
  <Box sx={{ mt: 5 }}>
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        color:
          selectedAction === "accepted"
            ? "success.main"
            : "error.main",
      }}
    >
      {selectedAction === "accepted"
        ? "Interview Accepted ✓"
        : "Interview Rejected ✕"}
    </Typography>

    <Typography
      variant="body1"
      sx={{
        mt: 2,
        color: "text.secondary",
      }}
    >
      {selectedAction === "accepted"
        ? "Thank you for confirming your availability. Your interview has been successfully accepted."
        : "You have declined this interview invitation. Thank you for letting us know."}
    </Typography>
  </Box>
)}
  </StyledContent>
</Container>
  
</Box>
    </>
  );
}